import { API } from "../../api/API";
import { validateResponseStatus } from "../../utils";

export const getDetailCourse = async (token, body, setShowModalError) => {
  const result = await API()
    .post("academy/course/byId", body)
    .catch((error) => {
      if (error.response) {
        if (error.response.status) return error.response;
        else return { error };
      } else {
        return { error };
      }
    });
  validateResponseStatus(result);
  if (result.status) {
    if (result.status === 200) {
      return {
        ...result.data,
        success: true,
      };
    } else {
      setShowModalError({
        show: true,
        message: `Ocurrió un error consultando el curso, estado de error: ${result.statusText}`,
      });
      return [];
    }
  } else {
    return [];
  }
};

export const getMyLearning = async (token, body, setShowModalError) => {
  const result = await API()
    .post("academy/course/mylearning", body)
    .catch((error) => {
      if (error.response) {
        if (error.response.status) return error.response;
        else return { error };
      } else {
        return { error };
      }
    });
  validateResponseStatus(result);
  if (result.status) {
    if (result.status === 200) {
      return result.data;
    } else {
      setShowModalError({
        show: true,
        message: `Ocurrió un error consultando el curso, estado de error: ${result.statusText}`,
      });
      return [];
    }
  } else {
    return [];
  }
};
